import { first } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

import { StreamService } from '../services';

@Component({
    styles: [`
        .email {
            overflow-x: hidden; 
            text-overflow: ellipsis; 
            max-height: 20px;
        }
    `],
    template: `
      <h2 mat-dialog-title>Followers for {{topic.title}}</h2>
      <spinner *ngIf="noTouching"></spinner>
      <div fxLayout="row" *ngIf="!noTouching">
        <div fxFlex="30"><h4>First Name</h4></div>
        <div fxFlex="30"><h4>Last Name</h4></div>
        <div fxFlex="40"><h4>Email</h4></div>
      </div>
      <mat-dialog-content>
        <div fxLayout="column" *ngIf="!noTouching">
            <div *ngFor="let follower of followers" fxLayout="row" [matTooltip]="followerTooltip(follower)" style="min-height: 30px;">
                <div fxFlex="30">{{follower.firstName}}</div>
                <div fxFlex="30">{{follower.lastName}}</div>
                <div fxFlex="40" class="email" [matTooltip]="follower.emailAddress">{{follower.emailAddress}}</div>
            </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">Done</button>
      </mat-dialog-actions>
    `
})
export class TopicFollowersDetails implements OnInit{
    noTouching: boolean = true;
    followers = [];

    constructor(public streamService: StreamService,
                @Inject(MAT_DIALOG_DATA) public topic: any) {};

    followerTooltip = follower => `${follower.firstName} ${follower.lastName} (${follower.emailAddress})`;

    ngOnInit() {
        this.streamService.getStreamFollowers(this.topic.id, { rows: 500}).pipe(first())
        .subscribe(results => {
            this.followers = _.sortBy(results.content, ['lastName', 'firstName']);
            this.noTouching = false;
        });
    };
}
